import { render, staticRenderFns } from "./_Competitions.vue?vue&type=template&id=04a70e22&"
import script from "./_Competitions.vue?vue&type=script&lang=js&"
export * from "./_Competitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports